import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { marker as l10n } from '@biesbjerg/ngx-translate-extract-marker';
import { IShellDisplay, SHELL_DISPLAY } from '@shared/metadata/IShellDisplay';
import { StreamlineIconsModule } from '@shared/icons/streamline-icons.module';
import { of } from 'rxjs';

const submitShellDisplay: IShellDisplay = {
  route: '/pages/standard-fitting/submit',
  navTitleKey: l10n('STANDARD_FITTING.SUBMIT.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:pencil-write-2',
  hideNavBar$: of(true),
};

const cloneShellDisplay: IShellDisplay = {
  route: '/pages/standard-fitting/clone',
  navTitleKey: l10n('STANDARD_FITTING.CLONE.NAV_TITLE'),
  navTitleSvgIcon: 'streamline:pencil-write-2',
  hideNavBar$: of(true),
};

@NgModule({
  declarations: [],
  imports: [MatIconModule, StreamlineIconsModule],
  providers: [
    { provide: SHELL_DISPLAY, useValue: submitShellDisplay, multi: true },
    { provide: SHELL_DISPLAY, useValue: cloneShellDisplay, multi: true },
  ],
})
export class StandardFittingMetadataModule {}
